import { FC } from "react";
import { FieldHookConfig, useField } from "formik";

import InputFieldAuth from "../../InputFieldAuth/InputFieldAuth";
import { InputFieldProps } from "../../InputField/types";

const FormikInputField: FC<InputFieldProps & FieldHookConfig<string>> = (
  props: InputFieldProps & FieldHookConfig<string>
) => {
  const [field, meta] = useField(props);

  return (
    <InputFieldAuth
      {...props}
      {...field}
      {...(meta.touched &&
        meta.error &&
        props.type !== "hidden" && { errorMessage: meta.error })}
    />
  );
};

export default FormikInputField;
